module.exports = __webpack_public_path__ + "resources/img/logo_partner_game_4_m2.644a9b116e26f6a7ff08d0c8c9b002e8.png";